<!-- 天气状况组件 -->
<template>
  <div class='weather' v-if="weatherForm.wea">
      <!-- <div id="time">图标</div> -->
      <!-- <img class="weatherImg" v-if="weatherForm.wea_img" :src="`${require}@/assets/images/index/${weatherForm.wea_img}.png`" alt=""> -->
      <img class="weatherImg" v-if="weatherForm.wea_img" :src="require(`./weatherImg/${weatherForm.wea_img}.png`)" alt="">
      <div class="wea" v-if="weatherForm.wea">
        &nbsp{{weatherForm.wea}}&nbsp
      </div>
      <div class="temperature">
        &nbsp{{ (weatherForm.tem_night,weatherForm.tem_day) ? (weatherForm.tem_night  + '  ~  ' + weatherForm.tem_day + '℃') : '' }}&nbsp
      </div>
      <div class="win">
        {{ (weatherForm.win || '-') + '      ' +  (weatherForm.win_speed || '  -  ')}}
      </div>
  </div>
</template>

<script>
  import request from 'axios'
  
  export default {
    components: {

    },
    data () {
      return {
        weatherForm:{
          humidity: '', // 湿度
          pressure: '', // 气压
          date: '', // 日期
          update_time: '', //温度更新时间
          win: '', // 风向
          win_meter: '', // 风速
          win_speed: '', // 风力
          tem: '', // 当前温度
          tem_day: '', // 当日最高气温
          tem_night: '', // 当日最低气温
          wea: '', // 天气状况
          cityid: '', // 城市ID
          city: '', // 城市名称
          week: '', // 星期几
          wea_img: '', // 天气图标
          air: '', //空气质量
        },
        weatherData: {
          bingbao: require('./weatherImg/bingbao.png'),
          lei: require('./weatherImg/lei.png'),
          qing: require('./weatherImg/qing.png'),
          shachen: require('./weatherImg/shachen.png'),
          wu: require('./weatherImg/wu.png'),
          xue: require('./weatherImg/xue.png'),
          yin: require('./weatherImg/yin.png'),
          yu: require('./weatherImg/yu.png'),
          yun: require('./weatherImg/yun.png'),
        }
      };
    },
    computed: {

    },
    methods: {
      dynamicIp(){
        request({
          url: 'https://bird.ioliu.cn/ip',
          type: 'GET'
        }).then(res => {
          console.log(res, '这是ip')
          console.log(res.data.data.ip)
          var cityip = res.data.data.ip;
          if(!cityip) return 
          this.dynamicGetWeather(cityip);
        })
      },
      dynamicGetWeather(cityip){
        console.log(cityip, '传入的ip')
        //声明一个pattern正则表达式规则，用来检测我们更新地区时传入的参数是ip地址还是汉字地区名称，如"广州"
        var pattern = new RegExp("[\u4E00-\u9FA5]+");
        // if(pattern.test(cityip)){
        //   console.log('这是没变的')
        //   //当传入的参数cityip为汉字时，我们将url中的参数设置为city=，以此来接收我们传入的城市名称来获取该城市的天气信息
        //   request({
        //   url: 'https://www.tianqiapi.com/api/?version=v1&city='+cityip,
        //   type: 'GET',
        //   params: {
        //     appid: '26148275',
        //     appsecret: '2id6H48Y',
        //     version: 'v6'
        //   },
        //   dataType: 'jsonp',
        //   }).then(res => {
        //     console.log(res, '天气1')
        //   })
        // }else{
        //   //当传入的参数cityip为ip地址(如：113.101.59.68)时，我们将url中的参数设置为ip=，以此来接收我们传入的ip来获取该城市的天气信息
        //   //这个方法一般只有页面第一次加载，或者页面刷新时才会执行，因为我们切换地区时，传入的都是汉字，执行的是if为true时执行的方法
        //   console.log('这是变的') 
        //   request({
        //     url: 'https://www.tianqiapi.com/api/?version=v1&ip='+cityip,
        //     type: 'GET',
        //     params: {
        //     appid: '26148275',
        //     appsecret: '2id6H48Y',
        //     version: 'v6'
        //   },
        //     dataType: 'jsonp',
        //   }).then(res => {
        //     console.log(res, '天气2')
        //   })  
        // }
        request({
          methods: 'get',
          url: 'https://tianqiapi.com/free/day',
          headers: {},
          params: {
            appid: '43656176', // 账号ID
            appsecret: 'I42og6Lm', // 账号密钥
            cityid: null, // 城市编号,不要带CN
            city: null, // 城市名称,不要带市和区
            ip: null, // IP地址
            callback: 0, // jsonp方式
          },
        })
          .then((res) => {
            this.weatherForm = res.data
            console.log(this.weatherForm, '天气')
          })
          .catch((error) => {
            console.log(error);
          })
      }
    },
    mounted() {

    },
    created() {
      this.dynamicIp()
    },
    props: [],//父组件向子组件传递的值
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style lang='scss' scoped=scoped>
	@import '@/assets/scss/pc.scss';
  .weatherImg{
    width: 25px;
    height:25px;
  }

  .weather{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
</style>